export default __webpack_public_path__ + "static/media/backoffice.bfd8a60c.jpg";